import React from 'react';

import QueryPolling from './QueryPolling';

import { useAppSelector } from '@shared/model';
import { selectGenerationLoading } from '@entities/generation-state';

const GenerationProgress = () => {
  const isLoading = useAppSelector(selectGenerationLoading);

  return <>{isLoading ? <QueryPolling /> : null}</>;
};

export default React.memo(GenerationProgress);
